export default __webpack_public_path__ + "static/media/gallery-wip-emitter-tip_02.4c7e0bbb.jpg";